import { render } from "./Code.vue?vue&type=template&id=2ddc5c2c&scoped=true&ts=true"
import script from "./Code.vue?vue&type=script&lang=ts"
export * from "./Code.vue?vue&type=script&lang=ts"

import "./Code.vue?vue&type=style&index=0&id=2ddc5c2c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ddc5c2c"]])

export default __exports__